import {SRV as ApiServer, HTTPError} from "./server/SRV.ts";
import MultiplexApi from "./server/MultiplexApi.ts";
import * as i18n from "./i18n.ts";
import * as modal from "./util/modal.ts";
import * as amplify from "./util/amplify.ts";
import * as libLocation from "./lib/location.ts";
import "./server/decoders.ts";
import { clearAuthorization } from "./server/Authorization.ts";

ApiServer.setDefaultErrorHandler(function(ex){
  if (ex.code === "http0"){
    throw ex

  }else if (ex.code === "httptimeout"){
    modal.alert('fw2.defaultError');
    ex.handledrejection = true;

  //means that the loadbalancer send us to a server in error
  //so we clean the cookie to make it do its job well
  }else if (ex.code === "http502" || ex.code === "http401"){
    clearAuthorization()
    amplify.publish("sessionExpired",{fromApi:true});
    return true;

  }else if (ex.code === "15" ||ex.code === "501" ||  ex.code === "507" ||  ex.code === "509"){
    // 501 no session ; 507 user deleted
    amplify.publish("sessionExpired",{fromApi:true});
    return true;
  }else if (ex.code === "510"){
    // 510 no family
    libLocation.goTo("fw2_signup_family.php");

  }else if(ex.code==="506"){
    libLocation.refresh().then(()=>modal.alert('fw2.apierrors.506'));

  }else if(ex.code==="23"){
    //TODO put this in the next elseif by moving the key
    modal.alert('event.FizApiDistinctOccurenceIntersectException');

  }else if(ex.code==="7" && ex.subCode){
    modal.oops(i18n.get('fw2.apierrors.7'+ex.subCode, ex));
  }else if(ex.code==="610"||ex.code==="611"){
    //limit of number of items
    if(ex.type==='event'){
      import('./calendar/calendarclean.ts').then(module=>{
        module.modalEventHardLimitReached()
      })
    }else if(ex.type==='task'){
      import('./list/list_clean.ts').then(module=>{
        module.taskHardLimitReach()
      })

    }else{
      modal.oops(i18n.get('fw2.apierrors.610'+ex.type, ex));

    }

  }else if(ex.code==="601"){
    //limit of number of items
    import('./server/Medias.ts').then(Medias=>Medias.quotaErrorHandler(ex.rightFlag))

  }else if(i18n.get('fw2.apierrors.'+ex.code) !== ('fw2.apierrors.'+ex.code)){
    modal.alert('fw2.apierrors.'+ex.code);

  }else{
    ApiServer.webjslog(ex+"\t"+ex.stack,function(){},function(){})
    throw ex;
  }
});

var apiByMetaEnum = {
    "contact":["ctcput","ctcdelete"],
    "event":["evtcreate","evtdelete","evtupdate"],
    "task":["taskcreate","taskcreate2","taskdelete","taskmark","taskupdate","taskupdate2"],
    "tasklist":["taskcreatelist","taskdeletelist","taskrespondsuggested"],
    "place":["poicreate","poicreatesimple","poiupdate","poidelete"],
    "family":["accinvite","famsendinvite","adminremove"],
    "media":["wallpublishmultiplepics"]
}
Object.entries(apiByMetaEnum).forEach(function([metaIdType,apis]){
  var amplifyied = function(){
    try{
      amplify.publish("modified",metaIdType)
    }catch(e){
      console.log(e);
    }
  }
  apis.forEach(function(api){
    ApiServer[api] = ApiServer[api].prepare(amplifyied)
  });
});
ApiServer.metadelete = ApiServer.metadelete.prepare(function(){
  var
    done = [],
    checkId = (id)=>{
      var type = id.substring(0,id.indexOf('/'));
      if(done.indexOf(type)===-1){
        done.push(type)
        amplify.publish("modified",type);
      }
    },
    ids = this.data.id;

  if(typeof ids==='string'){
    checkId(ids);
  }else if(Array.isArray(ids)){
    ids.forEach(checkId)
  }else{
    Object.values(ids).forEach(checkId)
  }

})
window.ApiServer = ApiServer;
window['M'] =  MultiplexApi;

export default ApiServer;